import React from "react";

const MOD_BADGE_CLASSES = {
  KO: "mod-badge--ko",
  PKO: "mod-badge--pko",
  Mystery: "mod-badge--mystery",
  "Hyper/Turbo": "mod-badge--hyper",
  Freezeout: "mod-badge--freezeout",
  Vanilla: "mod-badge--vanilla",
  SAT: "mod-badge--sat",
};

/**
 * Badge component displaying tournament modality with styled colors
 */
export const ModBadge = ({ mod }) => {
  return (
    <span className={`mod-badge ${MOD_BADGE_CLASSES[mod] || MOD_BADGE_CLASSES.Vanilla}`}>
      {mod}
    </span>
  );
};

export default ModBadge;
